import { createSlice, createAction } from '@reduxjs/toolkit'

const initBotProfile = {
    id: '',
    voiceId: '',
    avatarId: '',
    profileObj: {
        age: 0,
        gender: "",
        name: "",
        personalityObj: [],
        symptomsAndBehavioursObj: [],
        responseStyleObj: [],
        backgroundObj: [],
        storyObj: [],
        longMem: {},
        shortMem: ""
    }
}

const botProfileReducer = createSlice({
    name: 'botprofile',
    initialState: initBotProfile,
    reducers: {
        loadProfile: (state, action) => {
            const { profileObj = {} } = action.payload;
            console.log(state.profileObj.symptomsAndBehavioursObj)
            state.id = action.payload.id
            state.voiceId = action.payload.voiceId ?? ""
            state.avatarId = action.payload.avatarId ?? ""
            // Update profileObj selectively
            state.profileObj = {
                ...state.profileObj, // Retain existing fields
                ...profileObj, // Override with new fields
                personalityObj: profileObj.personalityObj ?
                [
                    ...state.profileObj.personalityObj,
                    ...profileObj.personalityObj
                ] : state.profileObj.personalityObj,
                symptomsAndBehavioursObj: profileObj.symptomsAndBehavioursObj ?
                [
                    ...state.profileObj.symptomsAndBehavioursObj,
                    ...profileObj.symptomsAndBehavioursObj
                ] : state.profileObj.symptomsAndBehavioursObj,
                responseStyleObj: profileObj.responseStyleObj ?
                [
                    ...state.profileObj.responseStyleObj,
                    ...profileObj.responseStyleObj
                ] : state.profileObj.responseStyleObj,
                backgroundObj: profileObj.backgroundObj ?
                [
                    ...state.profileObj.backgroundObj,
                    ...profileObj.backgroundObj
                ] : state.profileObj.backgroundObj,
                storyObj: profileObj.storyObj ?
                [
                    ...state.profileObj.storyObj,
                    ...profileObj.storyObj
                ] : state.profileObj.storyObj,
                longMem: profileObj.longMem ? 
                {
                    ...state.profileObj.longMem,
                    ...profileObj.longMem
                } : state.profileObj.longMem,
                shortMem: profileObj.shortMem ? 
                {
                    ...state.profileObj.shortMem,
                    ...profileObj.shortMem
                } : state.profileObj.shortMem,
                // longMem: action.payload.profileObj.longMem ?? state.profileObj.longMem, // Replace if provided
                // shortMem: action.payload.profileObj.shortMem ?? state.profileObj.shortMem, // Replace if provided
            }
            return
        },
        updateBotProfile: (state, action) => {
            // console.log(action.payload)
            let mutatedProfileObj = { ...state.profileObj }
            const targetKey = action.payload.key
            mutatedProfileObj[targetKey] = action.payload.value
            state.profileObj = mutatedProfileObj
        },
        updateBotProfileBulk: (state, action) => {
            let mutatedProfileObj = { ...state.profileObj }
            // you can update anything except id
            Object.keys(action.payload.profileObj).map((key, idx) => {
                if (key === "id") return
                const value = action.payload.profileObj[key]
                // console.log("the value is ",value)
                mutatedProfileObj[key] = value
            })
            state.profileObj = mutatedProfileObj
        },
        resetBot: state => {
            return initBotProfile
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createAction("RESET_REDUCER"), (state, action) => {
                // console.log("user reducer receives action", action)
                state = initBotProfile
            })
            .addDefaultCase((state, action) => {
                state = initBotProfile
            })
    },
})

// Action creators are generated for each case reducer function
export const { loadProfile, resetBot, updateBotProfile, updateBotProfileBulk } = botProfileReducer.actions

export default botProfileReducer.reducer